module.exports = __webpack_public_path__ + "images/neutral-filledabb88c5f586067803be41a080925228a.svg";